const replaceText = (text: string, searchValue: string, replacer: string) => {
  return text.replace(searchValue, replacer);
};

const openLinkInNewTab = (link: string) => {
  Object.assign(document.createElement("a"), {
    target: "_blank",
    href: link,
    rel: "noopener noreferrer",
  }).click();
};

export const handleAlibabaIconClick = (productName: string) => {
  const alibabaURL = `https://www.alibaba.com/trade/search?fsb=y&IndexArea=product_en&SearchText=${replaceText(productName, " ", "+")}`;

  openLinkInNewTab(alibabaURL);
};

export const handleAliExpressIconClick = (productName: string) => {
  const aliExpressURL = `https://www.aliexpress.com/w/wholesale-${replaceText(productName, " ", "-")}.html?SearchText=${replaceText(productName, " ", "+")}`;

  openLinkInNewTab(aliExpressURL);
};
